<template>
  <div id="LoggedIn" class="theme position-relative d-flex" >
    <div class="main float-lg-right">
      <b-container fluid  class="px-0">
          <TopNav></TopNav>
          <MobileNav></MobileNav>
          <ContentRouter />
          <Footer></Footer>
      </b-container>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import TopNav from "@/components/LoggedIn/TopNav.vue";
import MobileNav from "@/components/LoggedIn/MobileNav.vue";
import ContentRouter from "@/components/LoggedIn/ContentRouter.vue";
import Footer from "@/components/LoggedIn/Footer.vue";
import {mapState} from "vuex"

export default {
  name: "LoggedIn",
  components: {
    TopNav,
      MobileNav,
    ContentRouter,
    Footer,
  },
  data() {
    return {
    };
  },
  mounted() {
    if (!this.isLoggedIn) {
        this.$store.commit('logout')
        this.$router.push({name : 'login'})
    }
  },
    onActive() {
    },
    onIdle() {
        this.$store.dispatch('logout')
        this.$router.push({name : 'login'})
    },
  methods: {

  },
    computed:{
        ...mapState(['isLoggedIn'])
    },

};
</script>
<style lang="less">
    @import "../assets/responsiveness";
    @import "../assets/_theme-0";
.main {
    width: 100%;
    background: #014D71;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background: #014D71;
    }
  .content-container {
    max-width: 1160px;
    margin: auto;
  }
  .page-bg {
    width: 100%;
    padding-bottom: 30px;
  }
  .bg-white {
    background-color: #fff;
  }
  .bg-grey {
    background-color: #f7f7f7;
  }
  .bg-primary-dark {
    background-color: #3e1954;
  }
  .page-title {
    h2 {
      font-size: 3.8rem;
      letter-spacing: 0.7rem;
      font-family: "FilsonProBold", sans-serif;
    }
  }
  h3 {
    font-size: 2.1rem;
    font-family: ff-sari-web-regular, sans-serif;
    letter-spacing: 0.3rem;
    padding: 40px 0 30px 0;
      color: @brand-secondary;
  }
  h4 {
    font-family: ff-sari-web-regular, sans-serif;
    font-size: 1.7rem;
    margin-bottom: 30px;
  }
  .section-header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    flex-direction: row-reverse;
    &.section-header-right{
      flex-direction: row;
      .section-header-title {
        padding-right: 0;
        padding-left: 15px;
        text-transform: capitalize;
      }
    }
    .section-header-title {
      white-space: nowrap;
      padding-right: 10px;
    }
    .section-header-divider {
      height: 1px;
      background: #cdcdcd;
      width: 100%;
      transform: translateY(5px);
    }
  }
    .home-link{
        font-size: 18px;
        display: inline;
        padding-bottom: 5px;
        border-bottom: 5px solid #E83B75;
    }
}
</style>
